// DO NOT IMPORT FROM THIS. THIS IS OLD & DEPRECATED.
// THIS IS HERE ONLY TO SUPPORT SAGA
import { createBrowserHistory } from "history";

export default createBrowserHistory();
